import { render } from "./ReminderCard.vue?vue&type=template&id=8fe2e780&scoped=true&lang=pug"
import script from "./ReminderCard.vue?vue&type=script&lang=js"
export * from "./ReminderCard.vue?vue&type=script&lang=js"

import "./ReminderCard.vue?vue&type=style&index=0&id=8fe2e780&lang=scss&scoped=true"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe2e780"]])

export default __exports__